import React, { useState, useEffect } from "react";
import { TextField, InputAdornment } from "@mui/material";

// currencyFormatter.js
export const currencyFormatter = (value) => {
  if (value === null || value === undefined) {
    return "0.00";
  }
  return new Intl.NumberFormat("en-US", {
    // style: 'currency',
    // currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

//   export const formatNumber = (num) => {
//     if (num === "" || num === null) return "";
//     return Number(num).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };



const PriceInput = ({ value, onChange, label }) => {
  const formatNumber = (num) => {
    if (num === null || num === undefined || num === "") return "";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    // kur vjen value nga DB ose props, shfaq formatimin
    if (value !== undefined && value !== null) {
      setInputValue(formatNumber(value));
    }
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value;
    setInputValue(raw); // lejon çdo shkrim të përdoruesit
    // ruan si numër vetëm kur është valid
    const numeric = parseFloat(raw.replace(/,/g, ""));
    if (!isNaN(numeric)) {
      onChange(numeric);
    } else {
      onChange(""); // ose null
    }
  };

  const handleBlur = () => {
    const numeric = parseFloat(inputValue.replace(/,/g, ""));
    if (!isNaN(numeric)) {
      setInputValue(formatNumber(numeric)); // formaton vetëm kur humb fokus
    }
  };

  return (
    <TextField
      label={label}
      variant="filled"
      fullWidth
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        startAdornment: <InputAdornment position="start">€</InputAdornment>,
      }}
    />
  );
};

export default PriceInput;